var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B9CAC",
    fillRule: "evenodd",
    d: "M17.233 9.167c-5.467 0-9.9 4.432-9.9 9.9 0 5.259 4.102 9.561 9.28 9.88.967.06 1.72.862 1.72 1.83v1.73l3.347-3.06c.337-.309.779-.48 1.237-.48h3.85c5.467 0 9.9-4.433 9.9-9.9s-4.433-9.9-9.9-9.9zm-13.566 9.9C3.667 11.574 9.74 5.5 17.233 5.5h9.534c7.492 0 13.566 6.074 13.566 13.567 0 7.492-6.074 13.566-13.566 13.566h-3.139l-5.89 5.387a1.833 1.833 0 0 1-3.071-1.353V32.39c-6.266-1.2-11-6.709-11-13.324m9.166-2.567c0-1.012.821-1.833 1.834-1.833h9.166a1.833 1.833 0 0 1 0 3.666h-9.166a1.833 1.833 0 0 1-1.834-1.833m1.834 3.667a1.833 1.833 0 0 0 0 3.666h14.666a1.833 1.833 0 0 0 0-3.666z",
    clipRule: "evenodd"
  })));
};
export default SvgComments;